import axios from "axios";
import localStorageService from "./localStorageService";
import ConstantList from "../appConfig";
import UserService from "../services/UserService";
import history from "history.js";
import { getFileDescription } from "./PublicService";
import appConfig from "../appConfig";
import { SOLUTION_DEFAULT, SystemConfigCode } from "app/common/LocalConst";
import LocalConstants from "app/LocalConstants";

export function updateAppConfig(newConfigs) {
  Object.assign(appConfig, newConfigs);
}

function isNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

class JwtAuthService {
  getCurrentUser = async () => {
    let url = ConstantList.API_EN_POINT + "/user-ext/get-current-user";
    await axios.get(url).then((response) => {
      if (response.data) {
        this.setUser({ user: response.data })
        this.setModule(response.data?.modules?.map(item => item?.code))
        return response.data;
      }
    })
  };

  getAllSysConfigKey = async () => {
    let url = ConstantList.API_EN_POINT + "/system-config/search-by-page";
    let { data } = await axios.post(url, { pageIndex: 1, pageSize: 1000 });
    let urlStoreHub = ConstantList.API_EN_POINT + "/storeHub/get-store-system-config"
    let dataStoreHub = await axios.get(urlStoreHub);


    if (data?.content?.length > 0) {
      let dataLocal = {};
      for (let item of data.content) {
        let value = item.configValue;
        if (value === "true") {
          value = true;
        }
        if (value === "false") {
          value = false;
        }
        if (isNumber(value)) {
          value = +value;
        }

        if (item.configKey === SystemConfigCode.TREATMENT_PLAN_CARD_PRINT_LOGO.code && item?.configValue) {
          try {
            // if (!item?.configValue) {
            //   throw new Error("Chưa có cấu hình logo phiếu in liệu trình sản phẩm");
            // }

            await getFileDescription(item?.configValue).then(({ data }) => {
              localStorageService.setItem("treatmentPlanCardPrintLogo", URL.createObjectURL(data));
            })
          }
          catch (err) {
            console.error(err);
        
          }
        }

        if (item.configKey === SystemConfigCode.LOGO.code && item?.configValue) {
          try {
            // if (!item?.configValue) {
            //   throw new Error("Chưa có cấu hình logo hệ thống");
            // }

            await getFileDescription(item?.configValue).then(({ data }) => {
              localStorageService.setItem("imgLogo", URL.createObjectURL(data));
            })
          }
          catch (err) {
          }
        }

        if (item?.configKey === "SOLUTION") {
          value = localStorageService.parseJson(value, SOLUTION_DEFAULT)
        }

        dataLocal[item.configKey] = value;
      }

      localStorageService.setItem("sysConfig", dataLocal);
      updateAppConfig(localStorageService.getItem("sysConfig"));
    }
    localStorageService.setItem("PRINT_FORM_CODE", dataStoreHub?.data?.PRINT_FORM_CODE);
  };

  removeSysConfigKey = async () => {
    localStorageService.removeItem("sysConfig");
  }

  //get justRequestNumber


  logout = () => {
    if (ConstantList.AUTH_MODE === "Keycloak") {

      UserService.doLogout();
      this.setSession(null);
      this.removeUser();
      this.removeModules();
      // this.removeRequestNumber();
      this.removeListRequestNumber();
      this.removeListAdministrative();
      this.removeSysConfigKey()
      history.push(window.location.origin);
    } else {
      this.setSession(null);
      this.removeUser();
      this.removeModules();
      // this.removeRequestNumber();
      this.removeListRequestNumber();
      this.removeListAdministrative();
      history.push(ConstantList.LOGIN_PAGE);
    }
  };

  setSession(token) {
    if (token) {
      localStorageService.setItem("jwt_token", token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
      localStorage.removeItem("jwt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  }

  setLoginUser = (data) => {
    let user = {};
    user.token = data.access_token;
    this.setUser(user);
    this.setModule(user?.modules?.map(item => item?.code));
    return user;
  };

  //set token
  setLoginToken = (data) => localStorageService.setItem("auth_token", data);
  setUser = (user) => localStorageService.setItem("auth_user", user);
  setModule = (modules) => localStorageService.setItem("list_modules", modules);
  // setListProvince = (list) => localStorageService.setItem("list_province", list);
  // getListDistrict = (list) => localStorageService.setItem("list_district", list);
  // setListCommune = (list) => localStorageService.setItem("list_commune", list);
  // setRequestNum = (data) => localStorageService.setItem("current_request_number", data);
  setListRequestNumberData = (data) => localStorageService.setItem("search_list_request_number", data);
  removeUser = () => localStorage.removeItem("auth_user");
  removeModules = () => localStorage.removeItem("list_modules");
  // removeRequestNumber = () => localStorage.removeItem("current_request_number");
  removeListAdministrative = (list) => localStorageService.removeItem("list_administrative", list);
  removeListRequestNumber = () => localStorage.removeItem("search_list_request_number");
}

export default new JwtAuthService();